import Vue from 'vue';
import IntersectionObserver from 'intersection-observer';

Vue.use(IntersectionObserver);
